"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Add = function Add(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,1c6.1,0,11,4.9,11,11s-4.9,11-11,11S1,18.1,1,12S5.9,1,12,1 M12,0C5.4,0,0,5.4,0,12c0,6.6,5.4,12,12,12 c6.6,0,12-5.4,12-12C24,5.4,18.6,0,12,0L12,0z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,19c-0.3,0-0.5-0.2-0.5-0.5V5.5C11.5,5.2,11.7,5,12,5s0.5,0.2,0.5,0.5v13.1C12.5,18.8,12.3,19,12,19z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.5,12.5H5.5C5.2,12.5,5,12.3,5,12s0.2-0.5,0.5-0.5h13.1c0.3,0,0.5,0.2,0.5,0.5S18.8,12.5,18.5,12.5z"
  }));
};

var _default = Add;
exports["default"] = _default;